import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=668e3603"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('668e3603')) {
      api.createRecord('668e3603', component.options)
    } else {
      api.reload('668e3603', component.options)
    }
    module.hot.accept("./UserList.vue?vue&type=template&id=668e3603", function () {
      api.rerender('668e3603', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/UserList.vue"
export default component.exports